import { useTranslation } from "react-i18next";

import { PATHS } from "@/routes/paths";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AnnouncementFooterProps {
  setOpen: (open: boolean) => void;
}

export const AnnouncementFooter = ({ setOpen }: AnnouncementFooterProps) => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  const handleClick = () => {
    setOpen(false);
    navigate(PATHS.COMMON_PATHS.ANNOUNCEMENTS);
  };

  return (
    <div className="border-t bg-background">
      <button
        className="group flex w-full items-center justify-center gap-1.5 py-2.5 text-[11px] font-medium text-muted-foreground hover:text-primary transition-colors duration-150"
        onClick={handleClick}
      >
        {t("common:inbox.view_all_announcements")}
        <ArrowRight
          size={11}
          className="rtl-flip transition-transform duration-150 group-hover:translate-x-0.5"
        />
      </button>
    </div>
  );
};
